export default __webpack_public_path__ + "static/6795-42997c576026958b182badf34deabe4c.jpg";